import React from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import AuthorsView from "../../atoms/authors-view";

import { getSectionName } from "../../utils/utils";
import { handleTimeFormat } from "../../helper/date-utils";

import "./section-timestamp.m.css";

const SectionAndTimeStamp = ({ story, publisherName }) => {
  const isRepublished = story["published-at"] !== story["first-published-at"];
  const UpdatedTime = isRepublished
    ? handleTimeFormat(story["published-at"])
    : handleTimeFormat(story["first-published-at"]);

  return (
    <div styleName="wrapper" className="section-and-timestamp">
      <div styleName="content">
        <div styleName="author-links">
          <AuthorsView story={story} />
        </div>
        <span styleName="label">
          {isRepublished ? "Updated" : "Published"}:&nbsp;
          <time
            dateTime={
              isRepublished
                ? new Date(story["published-at"]).toISOString()
                : new Date(story["first-published-at"]).toISOString()
            }
            styleName="timestamp"
          >
            {UpdatedTime}
          </time>
        </span>
      </div>

      <div styleName="section-name-read-time">
        <div styleName="text">{getSectionName(story)}</div>
        <div styleName="content">
          {story["read-time"] && <span styleName="label">{`${story["read-time"]} min read`}</span>}
        </div>
      </div>
    </div>
  );
};

SectionAndTimeStamp.propTypes = {
  story: object,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(SectionAndTimeStamp);
